<template>
  <div>
    <BaseCompletePage
      :content="getCover"
      :sdnData="SDN_TEMPLATE"
      :sdnDataAdvised="SDN_TEMPLATE_ADVISED"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
// SDN dependencies
import { SDN_TEMPLATE, SDN_TEMPLATE_ADVISED } from "@/constants/sdn.constants";
import BaseCompletePage from "@/views/BaseCompletePage.vue";

export default {
  components: {
    BaseCompletePage,
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["getCover"]),
  },
  data() {
    return {
      SDN_TEMPLATE,
      SDN_TEMPLATE_ADVISED,
    };
  },
};
</script>
